import Main from "./pages/Main";
import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import thumbnail from "./resources/images/happyin-thumb.png";

import About from "./pages/About";
import Activities from "./pages/Activities";

import { Modal } from "./components/Modal";

import Header from "./components/Header";
import Footer from "./components/Footer";
import NotFound from "./pages/NotFound";

// import TermsAndPrivacy from "./pages/TermsAndPrivacy";
import AboutHistory from "./pages/AboutHistory";
import AboutDirections from "./pages/AboutDirections";
import ActivitiesCounseling from "./pages/ActivitiesCounseling";
import ActivitiesCommunity from "./pages/ActivitiesCommunity";
import Donate from "./pages/Donate";
import Service from "./pages/Service";
import SelfHelpGroup from "./pages/SelfHelpGroup";
import modal from "./resources/images/도시락 나눔-1.jpg";

function App() {
  const isPc = useMediaQuery({
    query: "(min-width:1024px)",
  });
  const isTablet = useMediaQuery({
    query: "(min-width:767px) and (max-width:1023px)",
  });
  const isMobile = useMediaQuery({
    query: "(max-width:767px)",
  });
  const nowMediaQuery = isPc
    ? "pc"
    : isTablet
    ? "tablet"
    : isMobile
    ? "mobile"
    : "";

  const [modalOpen, setModalOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  // const [useCTABtn, setUseCTABtn] = useState(false);

  // const openCTABtn = () => {
  //   setUseCTABtn(true);
  // };

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    if (dontShowAgain) {
      localStorage.setItem("skipModal", "true");
    }
    setModalOpen(false);
  };
  const clickedModalBtn = () => {
    openModal();
  };

  useEffect(() => {
    const skip = localStorage.getItem("skipModal");
    if (!skip) {
      setModalOpen(true);
    }
  }, []);

  if (process.env.NODE_ENV === "production") {
    console.log = function no_console() {};
    console.warn = function no_console() {};
  }

  const location = useLocation();
  // const { pathname } = useLocation();
  // useEffect(() => {
  // if (location.pathname === "/") {
  //   openCTABtn(true);
  // }
  // if (location.pathname === "/sandbox") {
  // setModalOpen(true);
  // }
  // if (location.pathname === "/termsnprivacy") {
  //   setHeaderFooterOpen(false);
  // } else {
  //   setHeaderFooterOpen(true);
  // }
  // }, [location.pathname]);

  const [headerFooterOpen, setHeaderFooterOpen] = useState(true);

  return (
    <div
      className={
        isPc
          ? "App pc"
          : isTablet
          ? "App tablet"
          : isMobile
          ? "App mobile"
          : "App"
      }
    >
      <img
        style={{
          display: "none",
        }}
        src={thumbnail}
        alt=""
      />
      {headerFooterOpen && (
        <Header
          nowMediaQuery={nowMediaQuery}
          clickedModalBtn={clickedModalBtn}
        />
      )}
      {/* {useCTABtn && nowMediaQuery === "mobile" && <CTABtn />} */}
      <Routes>
        <Route
          exact
          path="/"
          element={<Main nowMediaQuery={nowMediaQuery} />}
        ></Route>
        {/* 
        <Route
          exact
          path="/termsnprivacy"
          element={<TermsAndPrivacy />}
        ></Route> */}
        <Route
          exact
          path="/about"
          element={<About nowMediaQuery={nowMediaQuery} />}
        ></Route>
        <Route
          exact
          path="/history"
          element={<AboutHistory nowMediaQuery={nowMediaQuery} />}
        ></Route>

        <Route
          exact
          path="/directions"
          element={<AboutDirections nowMediaQuery={nowMediaQuery} />}
        ></Route>

        <Route
          exact
          path="/meal-sharing"
          element={<Activities nowMediaQuery={nowMediaQuery} />}
        ></Route>
        <Route
          exact
          path="/counseling"
          element={<ActivitiesCounseling nowMediaQuery={nowMediaQuery} />}
        ></Route>
        <Route
          exact
          path="/community"
          element={<ActivitiesCommunity nowMediaQuery={nowMediaQuery} />}
        ></Route>
        <Route
          exact
          path="/self-help-group"
          element={<SelfHelpGroup nowMediaQuery={nowMediaQuery} />}
        ></Route>

        <Route
          exact
          path="/donate"
          element={<Donate nowMediaQuery={nowMediaQuery} />}
        ></Route>
        <Route
          exact
          path="/service"
          element={<Service nowMediaQuery={nowMediaQuery} />}
        ></Route>

        {/* <Route 
          exact
          path="/sandbox"
          element={<Main nowMediaQuery={nowMediaQuery} />}
        ></Route>*/}

        <Route path="/*" element={<Navigate to="/notfound" />}></Route>
        <Route
          path="/notfound"
          element={<NotFound nowMediaQuery={nowMediaQuery} />}
        ></Route>
      </Routes>
      <Modal
        nowMediaQuery={nowMediaQuery}
        open={modalOpen}
        close={closeModal}
        header="　"
      >
        <main>
          <img
            src={modal}
            className="sandbox"
            alt=""
            style={{ width: "500px" }}
          />
          <div style={{}}>
            <label style={{ fontSize: "14px" }}>
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
              />
              다시 보지 않기
            </label>
          </div>
        </main>
      </Modal>
      {headerFooterOpen && <Footer />}
    </div>
  );
}

export default App;
